import User from './User';

export class Teacher extends User {
  static get entity() {
    return 'teachers';
  }

  static get fk() {
    return 'teacher';
  }

  static fields() {
    return {
      ...User.fields()
    };
  }

  static apiConfig = {
    actions: {
      ...User.apiConfig?.actions
    }
  };
}

export default Teacher;
